import { lazy } from 'react';

const Splashtech = lazy(() => import(/* webpackChunkName: "splashtech" */ './splashtech-page'));

export default Splashtech;
